import PropTypes from "prop-types";

import { useRef, useState, useEffect } from "react";

import Card from "react-bootstrap/Card";

import Form from "react-bootstrap/Form";

import Button from "react-bootstrap/Button";

import DesignedLabel from "../DesignedLabel";

import useWindowDimensions from "../useWindowDimensions";

import overlayImage1 from "../../assets/svg/overlayImage1.svg";

import overlayImage2 from "../../assets/svg/overlayImage2.svg";

import { isMobile, isTablet } from "react-device-detect";

import {
  REGISTER,
  LOG_IN,
  TOPIC_IMAGE_PATH_ON_ERROR,
  PREVIEW,
  IMAGE_BASE,
  TOPIC_NAME,
  TOPIC_MULTI_CHECKBOX,
  TOPIC_AUDIENCE,
  WORKSPACE_TYPE_PUBLIC,
  WORKSPACE_TYPE_PRIVATE,
  TOPIC_ICON_PATH,
  TOPIC_SEARCHTAGS,
  TRUE,
  FALSE,
  CERTAIN_TOPIC_AWAITING_ID,
} from "../../constants/stringConstants";

import { Link, useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";

import CustomModal from "../CustomModal";

import { connect } from "react-redux";

import { bindActionCreators } from "redux";

import {
  deleteTopicGroup,
  updateTopicGroup,
  doRestartTopicMessages,
} from "../../actions/topicActions";

import FieldsInForm from "../FieldsInForm";

import iconsEdit from "../../assets/svg/icons-edit.svg";

import iconsDelete from "../../assets/svg/icons-delete.svg";

const CardCustom = ({
  classNameOfCard,
  classNameOfOverlay,
  loggedIn,
  card,
  createdByUser,
  userToken,
  userEmail,
  deleteTopicGroup,
  updateTopicGroup,
  curatedRegHubTopics,
  currentWorkspace,
  doRestartTopicMessages,
}) => {
  const refCard = useRef(null);
  const { height, width } = useWindowDimensions();
  const [isHovered, setIsHovered] = useState(false);
  const [isDeletedDialogOpened, setIsDeletedDialogOpened] = useState(false);
  const [isEditDialogOpened, setIsEditDialogOpened] = useState(false);
  const [submitOccurred, setSubmitOccurred] = useState(false);
  const [didCompMount, setDidCompMount] = useState(false);
  const { t } = useTranslation();
  const [checkBoxCheckedIds, setCheckBoxCheckedIds] = useState([]);
  const [selectTopicAudience, setSelectTopicAudience] = useState(
    card.TOPIC_AUDIENCE
  );
  const argsForFields = {
      findFormErrors: (form) => {
        const { TOPIC_NAME } = form;
        const newErrors = {};

        if (!TOPIC_NAME || TOPIC_NAME === "")
          newErrors.TOPIC_NAME = t("topicNameIsAMandatoryField");
        else if (TOPIC_NAME.length > 48)
          newErrors.TOPIC_NAME = t("topicNameCantBeLongerThan48Charachteres");

        if (
          !checkBoxCheckedIds.length &&
          curatedRegHubTopics.filter((o) => o.TOPIC_STATUS !== "preview").length
        )
          newErrors.TOPIC_MULTI_CHECKBOX = t("youMustSelectAtLeastOneTopic");
        else if (
          checkBoxCheckedIds.length > 12 &&
          curatedRegHubTopics.filter((o) => o.TOPIC_STATUS !== "preview").length
        )
          newErrors.TOPIC_MULTI_CHECKBOX = t("youCantSelectMoreThan12Topics");

        if (!selectTopicAudience || selectTopicAudience === "")
          newErrors.TOPIC_AUDIENCE = t("topicAudienceIsAMandatoryField");

        return newErrors;
      },
      fields: [
        {
          name: TOPIC_NAME,
          type: "text",
          className: "register-login-text-field",
          required: true,
          classnameofgroup: "register-login-text-field-group",
          label: t("name"),
          placeholder: t("egEuropeanBakingRegulations"),
        },
        {
          name: TOPIC_AUDIENCE,
          type: "select",
          className: "register-login-text-field",
          options: [
            {
              description: t("privateWorkspace"),
              value: WORKSPACE_TYPE_PRIVATE,
            },
            { description: t("publicWorkspace"), value: WORKSPACE_TYPE_PUBLIC },
          ],
          required: true,
          disabled: currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE,
          displayProperty: "description",
          valueProperty: "value",
          label: t("groupAudience"),
        },
        {
          name: TOPIC_MULTI_CHECKBOX,
          type: "multi-checkbox",
          className: "register-login-text-field",
          required: false,
          classnameofgroup: "register-login-text-field-group",
          label: t("selectTopicsToBaseYourTopicOn"),
          data: curatedRegHubTopics.filter((o) => o.TOPIC_STATUS !== "preview"),
          displayProperty: TOPIC_NAME,
          valueProperty: TOPIC_NAME,
          imageProperty: TOPIC_ICON_PATH,
          replaceImageProperty: TOPIC_IMAGE_PATH_ON_ERROR,
          defaultChecked: TOPIC_SEARCHTAGS,
        },
      ],
      onSubmit: (values) => {
        console.log("curatedRegHubTopics", curatedRegHubTopics);
        let topic_search = "";

        checkBoxCheckedIds.forEach((o) => (topic_search += o + ";"));

        let data = {
          TOPIC_ID: values.TOPIC_ID,
          TOPIC_NAME: values.TOPIC_NAME,
          TOPIC_SEARCHTAGS: topic_search,
          TOPIC_AUDIENCE: values.TOPIC_AUDIENCE
            ? values.TOPIC_AUDIENCE
            : WORKSPACE_TYPE_PRIVATE,
        };

        onEditTopicGroup(data);
      },
      onCheckBoxChanged: (TOPIC_NAME) => {
        let found = checkBoxCheckedIds.find((el) => {
          return el === TOPIC_NAME;
        });

        if (found) {
          setCheckBoxCheckedIds(
            checkBoxCheckedIds.filter((o) => o !== TOPIC_NAME)
          );
        } else {
          checkBoxCheckedIds.push(TOPIC_NAME);
          setCheckBoxCheckedIds(checkBoxCheckedIds);
        }
      },
      onSelectBoxChanged: (TOPIC_AUDIENCE) => {
        setSelectTopicAudience(TOPIC_AUDIENCE);
      },
      classNameReactFormal: "register-login-react-formal",
      classNameForm: "register-login-react-form",
      existingData: card,
    },
    history = useHistory();

  function onMouseEnterLeave(value) {
    setIsHovered(value);
  }

  function onImgCardError(me) {
    me.target.src = TOPIC_IMAGE_PATH_ON_ERROR;
  }

  function onClickDeleteTopicGroup() {
    deleteTopicGroup(userToken, userEmail, card.TOPIC_ID);
    setIsDeletedDialogOpened(false);
  }

  function onEditTopicGroup(data) {
    updateTopicGroup(
      userToken,
      userEmail,
      data.TOPIC_ID,
      data.TOPIC_NAME,
      data.TOPIC_SEARCHTAGS,
      data.TOPIC_AUDIENCE
    );
    setIsEditDialogOpened(false);
  }

  useEffect(() => {
    if (checkBoxCheckedIds.length === 0 && !didCompMount) {
      let topic_search = [];

      card.TOPIC_SEARCHTAGS.split(";").forEach((tag) => {
        if (tag) {
          topic_search.push(tag);
        }
      });

      setDidCompMount(true);

      setCheckBoxCheckedIds(topic_search);
    }
  }, [
    card,
    checkBoxCheckedIds,
    setCheckBoxCheckedIds,
    didCompMount,
    setDidCompMount,
  ]);

  return (
    <>
      <Card
        onMouseEnter={() => onMouseEnterLeave(true)}
        onMouseLeave={() => onMouseEnterLeave(false)}
        className={
          createdByUser && card.TOPIC_TYPE !== "TOPIC"
            ? `${classNameOfCard} topic-groups cursor-pointer`
            : card.TOPIC_STATUS === PREVIEW && loggedIn
            ? `${classNameOfCard} cursor-not-allowed`
            : !loggedIn &&
              (isHovered || isMobile || isTablet) &&
              card.TOPIC_AUDIENCE !== WORKSPACE_TYPE_PUBLIC
            ? `${classNameOfCard} overlay-over-card`
            : classNameOfCard
        }
        ref={refCard}
      >
        <Card.Header
          onClick={() => {
            if (
              (loggedIn || card.TOPIC_AUDIENCE === WORKSPACE_TYPE_PUBLIC) &&
              card.TOPIC_STATUS !== PREVIEW
            ) {
              doRestartTopicMessages();
              history.push(CERTAIN_TOPIC_AWAITING_ID + card.TOPIC_ID);
            }
          }}
          className={
            createdByUser && card.TOPIC_TYPE !== "TOPIC"
              ? "fs-16"
              : "display-none"
          }
        >
          {createdByUser && card.TOPIC_TYPE !== "TOPIC" ? card.TOPIC_NAME : ""}
        </Card.Header>
        <Card.Body
          className={
            card.TOPIC_STATUS === PREVIEW && loggedIn
              ? "cursor-not-allowed"
              : "cursor-pointer"
          }
          onClick={() => {
            if (
              (loggedIn || card.TOPIC_AUDIENCE === WORKSPACE_TYPE_PUBLIC) &&
              card.TOPIC_STATUS !== PREVIEW
            ) {
              doRestartTopicMessages();
              history.push(CERTAIN_TOPIC_AWAITING_ID + card.TOPIC_ID);
            }
          }}
        >
          <Card.Title
            className={
              createdByUser && card.TOPIC_TYPE !== "TOPIC"
                ? "visibility-hidden"
                : ""
            }
          >
            <DesignedLabel
              classNameLabel={
                createdByUser && card.TOPIC_TYPE !== "TOPIC"
                  ? "display-none"
                  : card.TOPIC_STATUS === PREVIEW || card.SUBSCRIPTION === TRUE
                  ? "coming-soon-label fs-10"
                  : "visibility-hidden"
              }
              label={
                card.SUBSCRIPTION === FALSE
                  ? t("comingSoon").toUpperCase()
                  : t("subscribed").toUpperCase()
              }
            />
          </Card.Title>
          <Card.Text
            className={
              createdByUser && card.TOPIC_TYPE !== "TOPIC"
                ? "visibility-hidden"
                : ""
            }
          >
            <img
              //Here the TOPIC_ICON_PATH is going to be used
              src={card.TOPIC_ICON_PATH}
              className={
                card.TOPIC_STATUS === PREVIEW
                  ? !loggedIn &&
                    (isHovered || isMobile || isTablet) &&
                    card.TOPIC_AUDIENCE !== WORKSPACE_TYPE_PUBLIC
                    ? "card-image card-image-greyed-out card-image-greyed-out-logged-off"
                    : "card-image card-image-greyed-out"
                  : "card-image"
              }
              width={64}
              height={64}
              onError={onImgCardError}
            />
            <span
              className={
                card.TOPIC_STATUS === PREVIEW
                  ? "card-text"
                  : "card-text active-card-text"
              }
            >
              {card.TOPIC_NAME}
            </span>
          </Card.Text>
          <Card.Text
            className={
              card.CREATED_BY !== userEmail
                ? !loggedIn &&
                  (isHovered || isMobile || isTablet) &&
                  card.TOPIC_AUDIENCE !== WORKSPACE_TYPE_PUBLIC
                  ? "created-by-card-footer card-image-greyed-out-logged-off"
                  : "created-by-card-footer"
                : "display-none"
            }
          >
            <span className={"subheading fs-10"}>
              {t("createdBy")}
              {": " + card.CREATED_BY}
            </span>
          </Card.Text>
        </Card.Body>
        {!loggedIn &&
        (isHovered || isMobile || isTablet) &&
        card.TOPIC_AUDIENCE !== WORKSPACE_TYPE_PUBLIC ? (
          <>
            {width <= 1024 && height ? (
              <Card.Img
                src={overlayImage2}
                alt="overlayImageCard"
                className="card-overlay-image"
              ></Card.Img>
            ) : (
              <Card.Img
                src={overlayImage1}
                alt="overlayImageCard"
                className="card-overlay-image"
              ></Card.Img>
            )}
            <Card.ImgOverlay className={classNameOfOverlay}>
              <Card.Title className={"fs-16"}>
                {t("availableToRegisteredUsersOnly")}
              </Card.Title>
              <Card.Text>
                <Form as="span" className="card-overlay-buttons">
                  <Link to={REGISTER}>
                    <Button
                      as="input"
                      type="button"
                      value="Register"
                      variant="cyan-green"
                      className="card-button register-card-button fs-14"
                    />
                  </Link>
                  <Link to={LOG_IN}>
                    <Button
                      as="input"
                      type="button"
                      value="Log in"
                      className="card-button log-in-card-button fs-14"
                      variant="cyan-white"
                    />
                  </Link>
                </Form>
              </Card.Text>
            </Card.ImgOverlay>
          </>
        ) : (
          <div className="display-none" />
        )}
        <Card.Footer
          className={
            createdByUser && card.TOPIC_TYPE !== "TOPIC" ? "" : "display-none"
          }
        >
          {card.TOPIC_SEARCHTAGS.split(";").map((tag, index) => {
            if (tag)
              return (
                <img
                  key={tag + index}
                  src={IMAGE_BASE + tag.replace(/\s+/g, "-") + ".jpg"}
                  onError={onImgCardError}
                  width={16}
                  height={13}
                  className="card-topic-group-footer-img"
                />
              );
            else return null;
          })}
          <div className="card-topic-footer-options">
            <span
              onClick={() => setIsEditDialogOpened(true)}
              className="card-topic-group-footer-option"
            >
              <img
                width={24}
                height={24}
                src={iconsEdit}
                className="card-topic-group-footer-img"
              />
              {t("edit")}
            </span>
            <span
              className="card-topic-group-footer-option"
              onClick={() => setIsDeletedDialogOpened(true)}
            >
              <img
                width={24}
                height={24}
                src={iconsDelete}
                className="card-topic-group-footer-img"
              />
              {t("delete")}
            </span>
          </div>
        </Card.Footer>
      </Card>
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("deleteTopicGroup")}
        setIsShown={setIsDeletedDialogOpened}
        isShown={isDeletedDialogOpened}
        negativeAction={() => setIsDeletedDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToDeleteTopicGroup")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToDeleteTopicGroup")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("deleteTopicGroup")}
        positiveAction={() => onClickDeleteTopicGroup()}
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        titleOfModal={t("editGroupOfTopics")}
        positiveButton={t("saveEdits")}
        negativeButton={t("cancel")}
        isShown={isEditDialogOpened}
        setIsShown={setIsEditDialogOpened}
        negativeAction={() => setIsEditDialogOpened(false)}
        isBackdrop="static"
        isCentered={true}
        classNameOfModal="reghub-modal reghub-modal-create-new-topic-group"
        positiveAction={() => setSubmitOccurred(true)}
        formId="edit-topic-group-form"
        content={
          <FieldsInForm
            idOfForm="edit-topic-group-form"
            fields={argsForFields.fields}
            findFormErrors={argsForFields.findFormErrors}
            classNameForm={argsForFields.classNameForm}
            onSubmit={argsForFields.onSubmit}
            submitOccurred={submitOccurred}
            setSubmitOccurred={setSubmitOccurred}
            onCheckBoxChanged={argsForFields.onCheckBoxChanged}
            onSelectBoxChanged={argsForFields.onSelectBoxChanged}
            existingData={argsForFields.existingData}
          />
        }
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteTopicGroup: bindActionCreators(deleteTopicGroup, dispatch),
    updateTopicGroup: bindActionCreators(updateTopicGroup, dispatch),
    doRestartTopicMessages: bindActionCreators(
      doRestartTopicMessages,
      dispatch
    ),
  };
};

CardCustom.propTypes = {
  classNameOfCard: PropTypes.string.isRequired,
  classNameOfOverlay: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  card: PropTypes.shape({
    CREATED_BY: PropTypes.string,
    SUBSCRIPTION: PropTypes.string,
    TOPIC_AUDIENCE: PropTypes.string,
    TOPIC_ICON_PATH: PropTypes.string,
    TOPIC_ID: PropTypes.number,
    TOPIC_NAME: PropTypes.string,
    TOPIC_SEARCHTAGS: PropTypes.string,
    TOPIC_STATUS: PropTypes.string,
    TOPIC_TYPE: PropTypes.string,
  }),
  createdByUser: PropTypes.bool.isRequired,
  userToken: PropTypes.string.isRequired,
  userEmail: PropTypes.string.isRequired,
  deleteTopicGroup: PropTypes.func.isRequired,
  updateTopicGroup: PropTypes.func.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }),
  curatedRegHubTopics: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: PropTypes.string,
      SUBSCRIPTION: PropTypes.string,
      TOPIC_AUDIENCE: PropTypes.string,
      TOPIC_ICON_PATH: PropTypes.string,
      TOPIC_ID: PropTypes.number,
      TOPIC_NAME: PropTypes.string,
      TOPIC_SEARCHTAGS: PropTypes.string,
      TOPIC_STATUS: PropTypes.string,
    })
  ),
  doRestartTopicMessages: PropTypes.func.isRequired,
};

CardCustom.defaultProps = {
  classNameOfCard: "",
  classNameOfOverlay: "",
  loggedIn: false,
  card: PropTypes.shape({
    CREATED_BY: "",
    SUBSCRIPTION: "FALSE",
    TOPIC_AUDIENCE: "",
    TOPIC_ICON_PATH: "",
    TOPIC_ID: 0,
    TOPIC_NAME: "",
    TOPIC_SEARCHTAGS: "",
    TOPIC_STATUS: "",
  }),
  createdByUser: false,
  userToken: "",
  userEmail: "",
  deleteTopicGroup: () => {},
  updateTopicGroup: () => {},
  currentWorkspace: "",
  curatedRegHubTopics: [],
  doRestartTopicMessages: () => {},
};

export default connect(null, mapDispatchToProps)(CardCustom);
